import { __assign, __extends } from "tslib";
import DateUtils from '../../Dates/DateUtils';
export var YearsInYearView = 16;
var DatePickerOptions = /** @class */ (function () {
    function DatePickerOptions() {
    }
    return DatePickerOptions;
}());
export default DatePickerOptions;
var ProcessedDatePickerOptions = /** @class */ (function (_super) {
    __extends(ProcessedDatePickerOptions, _super);
    function ProcessedDatePickerOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProcessedDatePickerOptions.fromPartial = function (partialOptions) {
        var newObj = __assign({}, partialOptions);
        newObj.display3DayLetters = partialOptions.display3DayLetters !== undefined ? partialOptions.display3DayLetters : false;
        newObj.autoClose = partialOptions.autoClose !== undefined ? partialOptions.autoClose : true;
        newObj.formatString = partialOptions.formatString !== undefined ? partialOptions.formatString : DateUtils.defaultFormatString;
        var hasD = newObj.formatString.indexOf("d") >= 0, hasM = newObj.formatString.indexOf("M") >= 0, hasY = newObj.formatString.indexOf("y") >= 0;
        newObj.monthView = partialOptions.monthView !== undefined ? partialOptions.monthView : hasM && !hasD;
        newObj.yearView = partialOptions.yearView !== undefined ? partialOptions.yearView : hasY && !hasM && !hasD;
        newObj.timeOnly = partialOptions.timeOnly !== undefined ? partialOptions.timeOnly : (!hasD && !hasM && !hasY);
        newObj.yearsBeforeInYearView = partialOptions.yearsBeforeInYearView !== undefined ? partialOptions.yearsBeforeInYearView : YearsInYearView - 4;
        newObj.minDate = !!partialOptions.minDate ? new Date(partialOptions.minDate) : new Date(1000, 0, 1); //Setting this to a value before 1000 causes issues with the js date implementation.
        newObj.maxDate = !!partialOptions.maxDate ? new Date(partialOptions.maxDate) : new Date(9999, 11, 31);
        newObj.minDateNoTime = DateUtils.stripTime(newObj.minDate);
        newObj.maxDateNoTime = DateUtils.stripTime(newObj.maxDate);
        return newObj;
    };
    return ProcessedDatePickerOptions;
}(DatePickerOptions));
export { ProcessedDatePickerOptions };
